import { render, staticRenderFns } from "./WarehousingAdd.vue?vue&type=template&id=31ce07c4&scoped=true&"
import script from "./WarehousingAdd.vue?vue&type=script&lang=ts&"
export * from "./WarehousingAdd.vue?vue&type=script&lang=ts&"
import style0 from "./WarehousingAdd.vue?vue&type=style&index=0&id=31ce07c4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31ce07c4",
  null
  
)

export default component.exports